<div class="forbidden-div">   
        <div class="mat-subtitle-1">
                {{'App.Forbidden' | translate}}
        </div>
</div>